import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchLaneNames, fetchMachinesWithFilters } from './store/slice';
import MachineTopHead from './machine-top-head';
import MachineContent from './machine-content';
import MachineModals from './machine-modals';
import { actions as machinesAction } from './store/slice';
import { showModal } from 'Core/redux/main/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { CellService } from '../../service/api/cell-service';
import { parseMachineMaintenanceDeepLink } from './machine-maintenance-deep-link';

const { resetFilters } = machinesAction;
const { CELL_ADD_EDIT } = MODAL_TYPES;

const CellView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchMachinesWithFilters());
    dispatch(fetchLaneNames({}));
    return () => dispatch(resetFilters());
  }, []);

  useEffect(() => {
    const deepLink = parseMachineMaintenanceDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.machineId}:${deepLink.maintenanceId || ''}:${deepLink.workOrderNumber || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    const modalPayload = {
      id: deepLink.machineId,
      focusedMaintenanceId: deepLink.maintenanceId,
      focusedWorkOrderNumber: deepLink.workOrderNumber,
      focusedTabIndex: deepLink.maintenanceId ? 2 : 0,
    };

    dispatch(showModal(CELL_ADD_EDIT, modalPayload));
    openedDeepLinkKeyRef.current = key;

    let cancelled = false;
    (async () => {
      try {
        const response = await CellService.getMachineDetailsById(deepLink.machineId);
        if (cancelled || response.status !== 200 || !response.response) {
          return;
        }
        dispatch(
          showModal(CELL_ADD_EDIT, {
            ...response.response,
            id: response.response.id || deepLink.machineId,
            focusedMaintenanceId: deepLink.maintenanceId,
            focusedWorkOrderNumber: deepLink.workOrderNumber,
            focusedTabIndex: deepLink.maintenanceId ? 2 : 0,
          }),
        );
      } catch {
        // Keep the id-only modal if machine lookup fails.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, location.search]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Machine</h4>
              </div>
            </div>
            <MachineTopHead />
          </div>
          <MachineContent />
          <MachineModals />
        </div>
      </div>
    </div>
  );
};

export default CellView;
